<template>
  <div
    style="display: flex; padding: 7.375rem 2.5vw 1.5rem; overflow-x: hidden"
  >
    <div class="library-box" style="flex: 1; margin-right: 1.5rem">
      <!-- 新手引导组件 -->
      <Guide
          :steps="guideSteps"
          storage-key="my_app_guide_completed"
          @complete="onGuideComplete"
      />
      <div>
        <span class="scope-title">{{ $t("studentProgramme.category") }}</span>
        <img src="@/assets/images/way.png" width="18px;" @click="onStartGuide">
        <div class="guide1" ref="guide1">
        <div
          class="scope-text cursor-pointer"
          :class="scopeIndex == index ? 'active' : ''"
          v-for="(item, index) in scopeData"
          :key="index"
          @click="changeIndex(0, index)"
          ref="scope-text"
        >
          {{ item }}
        </div>
        </div>
      </div>
      <div class="scope-box" ref="scope-box">
        <span class="scope-title">{{ $t("studentProgramme.topic") }}</span>
        <div v-if="topicData[scopeIndex]">
          <div ref="guide2"
            class="scope-text cursor-pointer guide2"
            :class="topicIndex == index ? 'active' : ''"
            v-for="(item, index) in topicData[scopeIndex]"
            :key="index"
            @click="changeIndex(1, index, item.id)"
          >
            {{ item.number }}&nbsp;&nbsp;{{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="library-box" style="font-weight: bold; flex: 2.5">
      <div
        v-if="
          topicData[scopeIndex] && practisesList[scopeIndex + '-' + topicIndex]
        "
      >
        <div class="topic-title">
          {{ topicData[scopeIndex][topicIndex].name }}
        </div>
        <div ref="guide3"
          class="body guide3"
          v-for="(item, index) in practisesList[scopeIndex + '-' + topicIndex]"
          :key="index"
        >
          <div>
            <div class="text1">{{ $t("studentProgramme.practice1") }} ({{ index + 1 }})</div>
            <div
              class="text2"
              style="white-space: normal; word-break: break-all"
            >
              {{ item.desc || item.number || ' '}}
            </div>
          </div>
          <div style="white-space: nowrap">
            <button class="cursor-pointer" @click="showTeaching(item)">
              {{ $t("studentProgramme.watchTeaching") }}
            </button>
            <button
              class="cursor-pointer"
              @click="goExamination(item)"
            >
              {{ $t("studentProgramme.goPractice") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <PracticepreDialog
      v-if="teachingSwitch"
      :showDate="showDate"
      @closeDialog="teachingSwitch = false"
    ></PracticepreDialog>
  </div>
</template>

<script>
import { scope } from "@/biz/static-data";
import { getTopics, getTopicsDetail } from "@/api/topic";
import PracticepreDialog from "@/components/Teaching/practicepreDialog.vue";
import moment from 'moment'
import Guide from '@/components/guide/Guide.vue'
import {getUserInfo} from "@/utils/auth";
export default {
  components: {
    PracticepreDialog,Guide
  },
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      gradeId: null,
      scopeData: [],
      topicData: {},
      practisesList: {},
      scopeIndex: 0,
      topicIndex: 0,
      teachingSwitch: false,
      showDate: null,
      storageKey: 'user_guide_completed',
      // 需要引导的元素
      guideSteps: [
        {
          target: '.guide1',
          text: this.$t('studentProgramme.guide1'),
          position: 'bottom'
        },
        {
          target: '.guide2',
          text: this.$t('studentProgramme.guide2'),
          position: 'bottom'
        },
        {
          target: '.guide3',
          text: this.$t('studentProgramme.guide3'),
          position: 'bottom'
        }
      ]
    };
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$nextTick(() => {
          this.scopeData = scope[v];
        });

        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
    "$store.getters.currentGradeId": {
      handler(v) {
        this.gradeId = v;
        this.topicData = {};
        this.practisesList = {};
        this.scopeIndex = 0;
        this.topicIndex = 0;
        this.getTopics(0);
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.gradeId = this.$store.getters.currentGradeId;
    this.scopeData = scope[this.$store.getters.language];
    this.getTopics(0);
  },
  methods: {
    onStartGuide() {
      localStorage.setItem(this.storageKey, 'false');
      location.reload(); // 刷新当前页面
    },
    onGuideComplete() {
      // 存储一个值（例如：标记用户引导已完成）
      localStorage.setItem(this.storageKey, 'true'); // 存储字符串 'true'
    },
    // 进入答题页
    goExamination(item) {
      window.sessionStorage.curGradeId = this.gradeId;
      window.sessionStorage.curScopeId = this.scopeIndex;
      window.sessionStorage.triviaQuiz = "false"
      this.$router.push({
        path: '/examination',
        query: {
          type: 'library',
          topicId: this.topicData[this.scopeIndex][this.topicIndex].id,
          id: item.id,
          gradeId: this.gradeId,
          startTime: moment().format('YYYY-MM-DD HH:mm:ss')
        },
      })
    },
    changeIndex(i, index, id) {
      if (i == 0) {
        this.scopeIndex = index;
        this.topicIndex = 0;
        this.getTopics(index);
      } else {
        this.topicIndex = index;
        this.getTopicsDetail(index, id);
      }
    },
    getTopics(index) {
      if (!this.topicData[index]) {
        let form = {
          studentId: this.detail.id,
          gradeId: this.gradeId,
          scope: this.scopeIndex,
          _page: 0,
          _limit: 3000,
          lang: getUserInfo("userProfile").studying,//this.$store.getters.language == this.languageZhTc?0:1,
        };
        getTopics(form).then((v) => {
          if (v.data.length > 0) {
            // this.$set(this.topicData,index,v.data.sort((a,b)=>{return a.number-b.number}))
            this.topicData[index] = v.data.sort((a, b) => {
              return a.number - b.number;
            });
            this.getTopicsDetail(0, this.topicData[index][0].id);
          }
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        });
      }
    },
    getTopicsDetail(index, id) {
      let key = this.scopeIndex + "-" + index;
      if (!this.practisesList[key]) {
        getTopicsDetail(id).then((v) => {
          this.practisesList[key] = v.data.practises.sort((a, b) => {
            return a.number - b.number;
          });
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        });
      }
    },
    showTeaching(item) {
      this.teachingSwitch = true;
      this.showDate = { practise:item };
      this.showDate.topicsId = this.topicData[this.scopeIndex][this.topicIndex].id;
    },
  },
};
</script>

<style lang="scss" scoped>
.library-box {
  border-radius: 2.5rem;
  background: #ffffff;
  padding: 2rem;//3rem;
  font-size: 1.25rem;//1.5rem;
  height: 100%;
  .scope-box{
    margin-top: 2rem;//3rem;
  }
  .scope-title {
    font-size: 1.5rem;//2rem;
    color: #b62d2e;
    font-weight: bold;
  }
  .scope-title-2 {
    font-size: 1rem;//2rem;
    color: #000000;
    font-weight: bold;
  }
  .topic-title {
    font-size: 2.25rem;//3rem;
    font-weight: bold;
    color: #b62d2e;
    text-align: center;
    margin-bottom: 2rem;//3rem;
  }
  .body {
    display: flex;
    justify-content: space-between;
    background: #fef7ee;
    border-radius: 1.25rem;
    padding: 1.75rem;//2.5rem;
    margin-top: 1rem;
    align-items: center;
  }
  .scope-text {
    line-height: 1.5;
    background: #f9d8b1;
    border: 0.15rem #f1aa55 solid;
    border-radius: 0.75rem;
    padding: 0.25rem;
    margin: 0.25rem 0;
  }
  .scope-text.active {
    background: #d07d11;
    border: 0.15rem #f3b768 solid;
    font-weight: bold;
  }
  .text1 {
    color: #8e8e8e;
    line-height: 1.4;
  }
  .text2 {
    color: #b62d2e;
    font-size: 1.5rem;//2rem;
    line-height: 1.4;
  }
  button {
    background: #fcc03a;
    box-shadow: 0px 0.5rem 0 #c28c00;
    border: none;
    border-radius: 2.75rem;
    padding: 0.875rem 1.75rem;
    font-size: 1.5rem;//2rem;
    font-weight: bold;
    & + button {
      margin-left: 0.75rem;//1rem;
    }
  }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .library-box {
    padding: 1.375rem;
    font-size: 0.875rem;
    .scope-box{
        margin-top: 1.375rem;
      }
    .scope-title {
      font-size: 1.125rem;
    }
    .topic-title {
      font-size: 1.75rem;
      margin-bottom: 1.375rem;
    }
    .body {
      padding: 1.125rem;
    }
    button {
      padding: 0.625rem 1.25rem;
      font-size: 1.125rem;
      & + button {
        margin-left: 0.5rem;
      }
    }
    .text2 {
      font-size: 1.125rem;
    }
  }
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .library-box {
    padding: 1.75rem;
    font-size: 1.125rem;
    .scope-box{
        margin-top: 0.75rem;
      }
    .scope-title {
      font-size: 1.375rem;
    }
    .topic-title {
      font-size: 2rem;
      margin-bottom: 1.75rem;
    }
    .body {
      padding: 1.5rem;
    }
    button {
      padding: 0.75rem 1.5rem;
      font-size: 1.375rem;
      & + button {
        margin-left: 0.625rem;
      }
    }
    .text2 {
      font-size: 1.375rem;
    }
  }
}
</style>
